// extracted by mini-css-extract-plugin
export default {"about_container":"SectionAbout_about_container__zeEN8","about_description":"SectionAbout_about_description__zDKG2","container_picture":"SectionAbout_container_picture__psH+3"};